module.exports = __webpack_public_path__ + "img/codwarzone-cover.ae85136d.jpg";